export default {
  LABEL: 'label',
  VALUE: 'value',
  DISPLAY_ORDER: 'displayOrder',
  DOUBLE_DATA: 'doubleData',
  HIDDEN: 'hidden',
  DESCRIPTION: 'description',
  READ_ONLY: 'readOnly'
};